module.exports = __webpack_public_path__ + "img/checklist.92c1b14f.png";